/**
* 基础菜单 商品管理
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>修改储值信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search"></el-form>

    <el-form label-width="120px" :model="serv" ref="serv">
      <el-form-item label="名称" prop="name">
        <el-input size="small" disabled v-model="serv.name" auto-complete="off" placeholder="请输入品牌名称"></el-input>
      </el-form-item>
      <el-form-item v-if="serv2.groupId >= 1" label="" prop="name">
        <div id="">
          品牌商家储值金额以及实际获得金额需要在品牌更改
        </div>
      </el-form-item>
      <el-form-item v-if="serv2.groupId == 0" label="储值金额" prop="name">
        <el-input size="small" type="number" v-model="serv2.czAmount" auto-complete="off" placeholder="请输入储值金额" @change="xzg">
        </el-input>
      </el-form-item>
      <el-form-item v-if="serv2.groupId == 0" label="实际获得金额" prop="name">
        <el-input size="small" v-model="serv2.useAmount" auto-complete="off" placeholder="请输入实际获得金额" @change="xzg">
        </el-input>
      </el-form-item>
      <el-form-item v-if="serv2.groupId == 0" label="差价" prop="name">
        <el-input size="small" disabled v-model="serv2.rateBase1" auto-complete="off" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="触发续储金额" prop="limitAmount">
        <el-input size="small" disabled v-model="serv.limitAmount" auto-complete="off" placeholder="请输入开户名"></el-input>
      </el-form-item>
      <el-form-item label="基础折扣" prop="name">
        <el-input size="small" v-model="serv2.rateBase" auto-complete="off" placeholder="请输入预存折扣"></el-input>
        <div>[100-（实际获得金额-储值金额）÷实际获得金额*82.5]*10</div>
      </el-form-item>
      <el-form-item label="买单折扣" prop="name">
        <el-input size="small" v-model="serv2.rateSale" auto-complete="off" placeholder="请输入预存折扣"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="display: flex; justify-content: center;">
      <el-button size="small">取消</el-button>
      <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存
      </el-button>
    </div>

  </div>
</template>

<script>
  import {
    merchantDetail,
    updateGroupDiscount
  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        xg1: 0,
        editForm: {
          bank_info: '',
          branch_name: '',
          bank_id: '',
          token: localStorage.getItem('logintoken')
        },
        title: '添加',
        province1: [],
        province_code: '',
        city1: [],
        city_code: '',
        bankCode: '',
        branchlist: [],
        bank_id: '',
        mchId: this.$route.query.id,
        serv: '',
        serv2: '',
        bankCardNo: ''
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {

      this.merchantDetail()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      xzg() {
        this.serv2.rateBase1 = ((this.serv2.czAmount / this.serv2.useAmount) * 100).toFixed(0)
        console.log(this.serv2.rateBase)
      },
      // 获取公司列表
      merchantDetail() {
        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "mchId": this.mchId
        }
        merchantDetail(pro).then(res => {
          if (res.data.bankInfo) {
            res.data.bankInfo1 = res.data.bankInfo.split('|')
          } else {
            res.data.bankInfo1 = ['', '', '', '']
          }
          this.serv = JSON.parse(JSON.stringify(res.data))
          this.serv2 = JSON.parse(JSON.stringify(res.data))
          this.xzg()
          this.branch_name = res.data.bankInfo1[0]
          this.bankCardNo = res.data.bankInfo1[1]
          this.bank_id = res.data.bankInfo1[3]
          this.binlist()
        })
      },

      submitForm() {
        let pro = ''
        if (this.serv2.groupId == 0) {
          pro = {
            "userId": JSON.parse(localStorage.getItem('userdata')).muId,
            "fundsId": this.mchId,
            "czAmount": this.serv2.czAmount,
            "useAmount": this.serv2.useAmount,
            "rateBase": this.serv2.rateBase,
            "rateSale": this.serv2.rateSale
          }
        } else {
          pro = {
            "userId": JSON.parse(localStorage.getItem('userdata')).muId,
            "fundsId": this.mchId,
            "rateBase": this.serv2.rateBase,
            "rateSale": this.serv2.rateSale
          }
        }
        updateGroupDiscount(pro).then((res) => {
          if (res.code == 0) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            this.$router.push({
              name: '商家管理'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })

      }

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/bus/modifyTheStoredValue.vue